<template>
  <div class="section group">
    <div class="col span_1_of_2">
      <router-link :to="'/' + 'products/' + $i18n.locale">
        <div class="close"></div>
      </router-link>
      <div class="productData">
        <div>
          <br />
          <h3>
            <span
              class="field-value active"
              v-show="!showField('name')"
              @click="focusField('name')"
            >
              <strong>{{ product.name }}</strong>
            </span>
            <input
              v-show="showField('name')"
              class="field-value form-control inactive"
              v-model="product.name"
              type="text"
              maxlength="35"
              @focus="focusField('name')"
              @blur="
                $v.product.name.$touch()
                blurField('name')
              "
            />
          </h3>
          <template v-if="$v.product.name.$error">
            <div v-if="!$v.product.name.required" class="errorMessage2">
              {{ $t('productNameReq') }}
            </div>
          </template>
          <template v-if="$v.product.name.$invalid">
            <div v-if="!$v.product.name.maxLength" class="errorMessage1">
              {{ $t('productNameMaxLength') }}
            </div>
          </template>
          <template v-if="$v.product.name.$invalid">
            <div div v-if="!$v.product.name.minLength" class="errorMessage1">
              {{ $t('productNameMinLength') }}
            </div>
          </template>

          <div class="formInput">
            <span>{{ $t('prodDesc') }}</span>
            <div>
              <span
                class="field-value active"
                v-show="!showField('description')"
                @click="focusField('description')"
              >
                <strong>{{ product.description }}</strong>
              </span>
              <textarea
                v-show="showField('description')"
                class="field-value form-control inactive"
                v-model="product.description"
                maxlength="300"
                @focus="focusField('description')"
                @blur="
                  $v.product.description.$touch()
                  blurField('description')
                "
              >
              </textarea>
            </div>
            <template v-if="$v.product.description.$error">
              <div v-if="!$v.product.description.required" class="errorMessage">
                {{ $t('prodDescReq') }}
              </div>
            </template>
            <template v-if="$v.product.description.$invalid">
              <div
                v-if="!$v.product.description.maxLength"
                class="errorMessage1"
              >
                {{ $t('prodDescMaxLength') }}
              </div>
            </template>
          </div>
          <br />
          <div class="formInput">
            <span>{{ $t('purchasePrice') }} (eur) </span>
            <b-button
              class="questionMark"
              v-b-tooltip.hover
              :title="$t('purchasePrice?')"
              >?
            </b-button>
            <span
              class="field-value2 active2"
              v-show="!showField('purchase_price')"
              @click="focusField('purchase_price')"
            >
              <strong>{{
                product.purchase_price | formatToTwoDecimals
              }}</strong>
            </span>
            <input
              v-show="showField('purchase_price')"
              class="field-value2 inactive"
              v-model="product.purchase_price"
              type="number"
              maxlength="5"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              @focus="focusField('purchase_price')"
              @blur="
                $v.product.purchase_price.$touch()
                blurField('purchase_price')
              "
            />
          </div>

          <div class="formInput">
            <span>{{ $t('sellingPrice') }} (eur) </span>
            <b-button
              class="questionMark"
              v-b-tooltip.hover
              :title="$t('sellingPrice?')"
              >?</b-button
            >
            <!-- <br /> -->
            <span
              class="field-value2 active2"
              v-show="!showField('price')"
              @click="focusField('price')"
            >
              <strong>{{ product.price | formatToTwoDecimals }}</strong>
            </span>
            <input
              v-show="showField('price')"
              class="field-value2 inactive"
              v-model="product.price"
              type="number"
              maxlength="5"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              @focus="focusField('price')"
              @blur="
                $v.product.price.$touch()
                blurField('price')
              "
            />
            <template v-if="$v.product.price.$invalid">
              <div v-if="!$v.product.price.required" class="errorMessage3">
                {{ $t('sellingPriceReq') }}
              </div>
            </template>
          </div>

          <div class="formInput">
            <span>{{ $t('overallStock') }} ({{ $t('pcs') }}) </span>
            <b-button
              class="questionMark"
              v-b-tooltip.hover
              :title="$t('stock_general?2')"
              >?</b-button
            >
            <!-- <br /> -->
            <span
              class="field-value2 active2"
              v-show="!showField('stock_general')"
            >
              <strong>{{ product.stock_general }}</strong>
            </span>
            <!-- <input
              v-show="showField('stock_general')"
              class="field-value2 inactive"
              v-model="product.stock_general"
              type="number"
              maxlength="4"
              @focus="focusField('stock_general')"
              @blur="
                $v.product.stock_general.$touch()
                blurField('stock_general')
              "
            />
            <template v-if="$v.product.stock_general.$error">
              <div
                v-if="!$v.product.stock_general.required"
                class="errorMessage3"
              >
                {{ $t('overallStockReq') }}
              </div>
            </template> -->
          </div>
          <hr />
          <div class="formInput">
            {{ $tc('category', 1) }}:
            <strong v-if="!isEditing">{{ category.name }}</strong>
            <multiselect
              v-else
              v-model="category"
              :options="categoryNames"
              :searchable="false"
              :close-on-select="true"
              track-by="id"
              label="name"
              :placeholder="$t('selectProdCat')"
              :show-labels="false"
              @change="categorySelect"
            ></multiselect>
            <span>
              <br />
              <div save-btn-box>
                <button
                  class="save-btn"
                  v-if="isEditing"
                  @click="changeProductDetails"
                >
                  <span> {{ $t('save') }} </span>
                </button>
              </div>
              <br />
              <div
                class="edit-btn"
                @click="
                  isEditing = !isEditing
                  isActive = !isActive
                "
              >
                <font-awesome-icon class="icon" icon="edit" />
                <span> {{ $t('changeCategory') }} </span>
              </div>
              <br />
              <div
                class="edit-btn"
                v-if="product.parent_product_id"
                @click="contactSupplier"
              >
                <button style="letter-spacing: 0px;">
                  <font-awesome-icon class="icon" icon="truck" />
                  <span> {{ $t('contactSupplier') }} </span>
                </button>
              </div>
            </span>
          </div>
        </div>
        <br />
        <div id="selector">
          <div class="checkbox">
            <label class="form-control2">
              <input
                type="checkbox"
                v-model="product.shippable"
                :true-value="1"
                :false-value="0"
                @click="changeProductDetails('shippable')"
              />
              {{ $t('offerGuestDelivery') }}
            </label>
          </div>
        </div>
        <div v-if="product.shippable">
          <p class="titlePickUp">{{ $t('packageDetails') }}</p>
          <p class="limitPickUp">{{ $t('packageLimits') }}</p>
          <div class="formInput">
            <span>{{ $t('weight') }} (kg):</span>
            <span
              class="field-value active"
              v-show="!showField('pkg_weight')"
              @click="focusField('pkg_weight')"
            >
              {{ product.pkg_weight }}
            </span>
            <input
              v-show="showField('pkg_weight')"
              v-model="product.pkg_weight"
              type="number"
              min="1"
              step="1"
              maxlength="3"
              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
              class="field-value form-control inactive"
              @focus="focusField('pkg_weight')"
              @blur="
                $v.product.pkg_weight.$touch()
                blurField('pkg_weight')
              "
            />
            <template v-if="$v.product.pkg_weight.$invalid">
              <div v-if="!$v.product.pkg_weight.required" class="errorMessage">
                {{ $t('weightReq') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('width') }} (cm): </span>
            <span
              class="field-value active"
              v-show="!showField('pkg_width')"
              @click="focusField('pkg_width')"
            >
              {{ product.pkg_width }}
            </span>
            <input
              v-show="showField('pkg_width')"
              v-model="product.pkg_width"
              class="field-value form-control inactive"
              type="number"
              min="1"
              step="1"
              maxlength="3"
              @focus="focusField('pkg_width')"
              @blur="
                $v.product.pkg_width.$touch()
                blurField('pkg_width')
              "
            />
            <template v-if="$v.product.pkg_width.$invalid">
              <div v-if="!$v.product.pkg_width.required" class="errorMessage">
                {{ $t('widthReq') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('height') }} (cm): </span>
            <span
              class="field-value active"
              v-show="!showField('pkg_height')"
              @click="focusField('pkg_height')"
            >
              {{ product.pkg_height }}</span
            >
            <input
              v-show="showField('pkg_height')"
              v-model="product.pkg_height"
              type="number"
              class="field-value form-control inactive"
              min="1"
              step="1"
              maxlength="3"
              @focus="focusField('pkg_height')"
              @blur="
                $v.product.pkg_height.$touch()
                blurField('pkg_height')
              "
            />
            <template v-if="$v.product.pkg_height.$invalid">
              <div v-if="!$v.product.pkg_height.required" class="errorMessage">
                {{ $t('heightReq') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('length') }} (cm): </span>
            <span
              class="field-value active"
              v-show="!showField('pkg_length')"
              @click="focusField('pkg_length')"
            >
              {{ product.pkg_length }}</span
            >
            <input
              v-show="showField('pkg_length')"
              v-model="product.pkg_length"
              class="field-value form-control inactive"
              type="number"
              min="1"
              step="1"
              maxlength="3"
              @focus="focusField('pkg_length')"
              @blur="
                $v.product.pkg_length.$touch()
                blurField('pkg_length')
              "
            />
            <template v-if="$v.product.pkg_length.$invalid">
              <div v-if="!$v.product.pkg_length.required" class="errorMessage">
                {{ $t('lengthReq') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('pickupAddress') }} : </span>
            <span
              class="field-value active"
              v-show="!showField('pickup_address')"
              @click="focusField('pickup_address')"
            >
              {{ product.pickup_address }}
            </span>
            <input
              v-show="showField('pickup_address')"
              v-model="product.pickup_address"
              ref="autocomplete"
              class="field-value form-control inactive"
              type="text"
              @focus="focusField('pickup_address')"
              @blur="
                $v.product.pickup_address.$touch()
                blurField('pickup_address')
              "
            />
            <template v-if="$v.product.pickup_address.$invalid">
              <div
                v-if="!$v.product.pickup_address.required"
                class="errorMessage"
              >
                {{ $t('addressReq') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('postalCode') }} : </span>
            <span
              class="field-value active"
              v-show="!showField('pickup_postal_code')"
              @click="focusField('pickup_postal_code')"
            >
              {{ product.pickup_postal_code }}
            </span>
            <input
              v-show="showField('pickup_postal_code')"
              v-model="product.pickup_postal_code"
              class="field-value form-control inactive"
              type="text"
              @focus="focusField('pickup_postal_code')"
              @blur="
                $v.product.pickup_postal_code.$touch()
                blurField('pickup_postal_code')
              "
            />
            <template v-if="$v.product.pickup_postal_code.$invalid">
              <div
                v-if="!$v.product.pickup_postal_code.required"
                class="errorMessage"
              >
                {{ $t('postalCodeReq') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('city2') }} : </span>
            <span
              class="field-value active"
              v-show="!showField('pickup_city')"
              @click="focusField('pickup_city')"
            >
              {{ product.pickup_city }}
            </span>
            <input
              v-show="showField('pickup_city')"
              v-model="product.pickup_city"
              class="field-value form-control inactive"
              type="text"
              @focus="focusField('pickup_city')"
              @blur="
                $v.product.pickup_city.$touch()
                blurField('pickup_city')
              "
            />
            <template v-if="$v.product.pickup_city.$invalid">
              <div v-if="!$v.product.pickup_city.required" class="errorMessage">
                {{ $t('cityReq') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('country') }} : </span>
            <country-select
              :country="product.pickup_country"
              v-model="product.pickup_country"
              class="field inputStyle"
              topCountry="SI"
              :countryName="true"
              :autocomplete="true"
              :usei18n="false"
              @input="changeProductDetails('pickup_country')"
              @blur="$v.product.pickup_country.$touch()"
            />
          </div>
        </div>
        <br />
        <div id="selector2" v-if="!product.parent_product_id">
          <div class="checkbox">
            <label class="form-control2">
              <input
                type="checkbox"
                v-model="product.wholesalable"
                :true-value="1"
                :false-value="0"
                @click="changeProductDetails('wholesalable')"
              />
              {{ $t('offerToOtherClients') }}
            </label>
          </div>
        </div>
        <div v-if="product.wholesalable">
          <p class="titlePickUp">{{ $t('wholesaleDetails') }}</p>
          <div class="formInput">
            <span>{{ $t('wholesale_price') }}:</span>
            <span
              class="field-value active"
              v-show="!showField('wholesale_price')"
              @click="focusField('wholesale_price')"
            >
              {{ product.wholesale_price | formatToTwoDecimals }}
            </span>
            <input
              v-show="showField('wholesale_price')"
              v-model="product.wholesale_price"
              type="number"
              maxlength="20"
              class="field-value form-control inactive"
              @focus="focusField('wholesale_price')"
              @blur="
                $v.product.wholesale_price.$touch()
                blurField('wholesale_price')
              "
            />
            <template v-if="$v.product.wholesale_price.$invalid">
              <div
                v-if="!$v.product.wholesale_price.required"
                class="errorMessage"
              >
                {{ $t('wholesale_price_req') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('sugg_selling_price') }}:</span>
            <span
              class="field-value active"
              v-show="!showField('sugg_selling_price')"
              @click="focusField('sugg_selling_price')"
            >
              {{ product.sugg_selling_price | formatToTwoDecimals }}
            </span>
            <input
              v-show="showField('sugg_selling_price')"
              v-model="product.sugg_selling_price"
              type="number"
              maxlength="5"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              class="field-value form-control inactive"
              @focus="focusField('sugg_selling_price')"
              @blur="
                $v.product.sugg_selling_price.$touch()
                blurField('sugg_selling_price')
              "
            />
            <template v-if="$v.product.sugg_selling_price.$invalid">
              <div
                v-if="!$v.product.sugg_selling_price.required"
                class="errorMessage"
              >
                {{ $t('sugg_selling_price_req') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('moq') }}:</span>
            <span
              class="field-value active"
              v-show="!showField('moq')"
              @click="focusField('moq')"
            >
              {{ product.moq }}
            </span>
            <input
              v-show="showField('moq')"
              v-model="product.moq"
              type="number"
              maxlength="20"
              class="field-value form-control inactive"
              @focus="focusField('moq')"
              @blur="
                $v.product.moq.$touch()
                blurField('moq')
              "
            />
            <template v-if="$v.product.moq.$invalid">
              <div v-if="!$v.product.moq.required" class="errorMessage">
                {{ $t('moq_req') }}
              </div>
            </template>
          </div>
          <div class="formInput">
            <span>{{ $t('infoPackSizes') }}:</span>
            <span
              class="field-value active"
              v-show="!showField('info_pack_sizes')"
              @click="focusField('info_pack_sizes')"
            >
              {{ product.info_pack_sizes }}
            </span>
            <input
              v-show="showField('info_pack_sizes')"
              v-model="product.info_pack_sizes"
              type="text"
              maxlength="500"
              class="field-value form-control inactive"
              @focus="focusField('info_pack_sizes')"
              @blur="
                $v.product.info_pack_sizes.$touch()
                blurField('info_pack_sizes')
              "
            />
          </div>
        </div>
      </div>
      <p class="editInstructions">{{ $t('editInstructions') }}</p>
      <br />
    </div>

    <div class="col span_1_of_2">
      <ProductImageUpload
        :isProductFlowEnabled="true"
        :experienceId="0"
        :productId="product.id"
        :imageUrl="product.img_path"
      />
      <!-- <figure class="about-img3">
				<img class="uploadExample" src="../assets/static/images/uploadExamples/productVideo_example.jpg" />            
			</figure> -->
      <template>
        <div class="pricing-switcher">
          <div class="fieldset">
            <input
              type="radio"
              name="group-a"
              :value="true"
              id="video"
              v-model="captureVideo"
            />
            <label for="video">{{ $tc('upload', 2) }}</label>
            <input
              type="radio"
              name="group-a"
              :value="false"
              id="url"
              v-model="captureVideo"
            />
            <label style="font-size: 15px;" for="url">{{
              $tc('addURL', 2)
            }}</label>
            <span class="switch"></span>
          </div>
        </div>
      </template>
      <videoUpload
        v-if="captureVideo"
        :isProductFlowEnabled="true"
        :product="product"
      />

      <div v-else class="formYT">
        <span
          ><img class="ytIcon" src="../assets/static/icons/youtube-logotype.png"
        /></span>
        <input
          type="text"
          class="urlInput"
          v-model="videoUrl"
          :placeholder="$t('copyURL')"
          @blur="$v.videoUrl.$touch()"
        />
        <template v-if="$v.videoUrl.$invalid">
          <div v-if="!$v.videoUrl.url" class="errorMessage">
            {{ $t('validUrlReq') }}
          </div>
        </template>
        <br />
        <br />
        <button class="save-btn" @click="saveProductVideoUrl()">
          {{ $t('save') }}
        </button>
      </div>
      <br />
      <router-link class="mobileOnly" :to="'/' + 'products/' + $i18n.locale">
        <div class="delete-btn">
          <font-awesome-icon class="icon" icon="chevron-left" /><span>
            {{ $t('backToCatalogue') }}</span
          >
        </div>
      </router-link>
      <br />
      <div class="delete-btn" @click="deleteProduct">
        <font-awesome-icon class="icon" icon="trash" />
        <span>{{ $t('removeProduct') }}</span>
      </div>
      <ConfirmDialog
        :visible="showConfirmation"
        class="customClass"
      ></ConfirmDialog>
    </div>
    <b-modal id="product-inquiry-modal" hide-footer>
      <template v-slot:modal-title>
        <!-- {{ $t('productInquiryForm') }} -->
      </template>
      <ProductInquiryForm
        :productDetails="marketPlaceProduct"
        :clientDetails="clientDetails[0]"
        :inquireDetails="inquireDetails"
        @hide-product-inquiry-form="hideProductInquiryForm"
      />
    </b-modal>
  </div>
</template>

<script>
import ProductImageUpload from '../components/ui/ProductImageUpload.vue'
import videoUpload from '@/components/ui/videoUpload.vue'
import ProductInquiryForm from '@/components/forms/ProductInquiryForm.vue'
import axios from 'axios'
import ShippingService from '@/services/ShippingService'
import countryLookup from 'country-code-lookup'
import ConfirmDialog from 'primevue/confirmdialog'
import { required, maxLength, minLength, url } from 'vuelidate/lib/validators'

export default {
  components: {
    ProductImageUpload,
    videoUpload,
    ProductInquiryForm,
    ConfirmDialog
  },
  metaInfo() {
    return {
      title: this.title
    }
  },
  data() {
    return {
      title: 'Product',
      id: this.product.id,
      isEditing: false,
      isActive: false,
      categoryNames: [],
      supplierNames: [],
      inquireDetails: {},
      clientDetails: [],
      marketPlaceProduct: {},
      category: null,
      supplier: null,
      captureVideo: true,
      videoUrl: null,
      showConfirmation: false,
      isDimensionValid: false,
      vueQuickEditClasses: {
        wrapper: 'form-group form-inline',
        input: 'formControl input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      vueQuickEditClassesTitleName: {
        wrapper: 'form-group titleName form-inline',
        input: 'formControl input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      vueQuickEditClassesShortInput: {
        wrapper: 'form-group form-inline',
        input: 'formControl short input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      vueQuickEditClassesTextArea: {
        wrapper: 'form-group form-inline textBoxArea',
        input: 'formControl addInfoArea input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      editField: ''
    }
  },
  validations: {
    product: {
      name: { required, maxLength: maxLength(20), minLength: minLength(3) },
      description: { required, maxLength: maxLength(300) },
      purchase_price: {},
      price: { required },
      stock_general: { required },
      shippable: {},
      wholesalable: {},
      pkg_weight: { required },
      pkg_height: { required },
      pkg_length: { required },
      pkg_width: { required },
      pickup_address: { required },
      pickup_postal_code: { required },
      pickup_city: { required },
      wholesale_price: { required },
      sugg_selling_price: { required },
      moq: { required },
      info_pack_sizes: {}
    },
    videoUrl: { url }
  },
  filters: {
    formatToTwoDecimals: function(value) {
      if (value) {
        return parseFloat(value).toFixed(2)
      }
    }
  },
  async created() {
    this.inquireDetails = JSON.parse(localStorage.getItem('user'))
    this.clientDetails = await this.$store.dispatch(
      'client/fetchClient',
      this.inquireDetails.id
    )
    const body = {
      parent_product_id: this.product.parent_product_id,
      parent_product_type: this.product.parent_product_type
    }
    if (this.product.parent_product_id)
      this.marketPlaceProduct = await this.$store.dispatch(
        'marketPlace/fetchMarketPlaceProductById',
        body
      )
  },
  mounted() {
    this.title = this.product.name
    this.videoUrl = this.product.video_path
    const fieldsToConsiderBlank = [
      'pkg_weight',
      'pkg_height',
      'pkg_width',
      'pkg_length',
      'pickup_address',
      'pickup_postal_code',
      'pickup_city',
      'wholesale_price',
      'sugg_selling_price',
      'moq',
      'info_pack_sizes'
    ]
    for (const field in this.product) {
      if (
        this.product[field] === null &&
        fieldsToConsiderBlank.indexOf(field) > -1
      )
        this.product[field] = ''
    }
    axios
      .all([
        axios.get(`${process.env.VUE_APP_API_URL}/productCategories`),
        axios.get(`${process.env.VUE_APP_API_URL}/suppliers`)
      ])
      .then(
        axios.spread((productCategoriesRes, suppliersRes) => {
          if (this.product.shippable) {
            const self = this
            setTimeout(() => {
              self.widget = new window.google.maps.places.Autocomplete(
                self.$refs.autocomplete,
                { types: ['geocode'] }
              )
              self.widget.addListener('place_changed', () => {
                self.setValues()
              })
            }, 100)
          }
          this.categoryNames = productCategoriesRes.data
          this.category = this.categoryNames.find(
            option => option.id === this.product.prodCat_id
          )

          this.supplierNames = suppliersRes.data
          this.supplier = this.supplierNames.find(
            option => option.id === this.product.supplier_id
          )
        })
      )
  },
  methods: {
    focusField(name) {
      this.editField = name
    },
    blurField(name) {
      this.editField = ''
      this.changeProductDetails(name)
    },
    showField(name) {
      return this.product[name] == '' || this.editField == name
    },
    setValues() {
      this.product.pickup_postal_code = ''
      this.product.pickup_city = ''
      this.product.pickup_country = ''
      this.product.pickup_address = this.$refs.autocomplete.value
      const placeDetails = this.widget.getPlace()
      placeDetails.address_components.forEach(addressComp => {
        if (addressComp.types.includes('locality'))
          this.product.pickup_city = addressComp.long_name
        if (addressComp.types.includes('postal_code'))
          this.product.pickup_postal_code = addressComp.long_name
        if (addressComp.types.includes('country'))
          this.product.pickup_country = addressComp.long_name
      })
    },
    async validateAddress() {
      const validationResponse = await ShippingService.getValidateAddress({
        StreetAddress: this.product.pickup_address,
        City: this.product.pickup_city,
        PostalCode: this.product.pickup_postal_code,
        CountryCode: countryLookup.byCountry(this.product.pickup_country).iso2
      })
      if (validationResponse.data.status === 'VALID') return true
      return false
    },
    deleteProduct() {
      this.$confirm.require({
        message: this.$t('confirmProductDelete'),
        header: this.$t('areYouSure'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.$store
            .dispatch('product/removeProduct', this.id)
            .then(() => {
              this.$router.push({
                path: '/products/en'
              })
            })
            .catch(e => console.log(e))
        },
        reject: () => {
          this.showConfirmation = false
        }
      })
    },
    async changeProductDetails(propertyName) {
      if (typeof this.product[propertyName] === 'string')
        this.product[propertyName] = this.product[propertyName].replace(
          /^0+/,
          ''
        )
      if (propertyName === 'shippable' || propertyName === 'wholesalable')
        this.product[propertyName] = !this.product[propertyName]
      if (
        this.product.shippable == 1 &&
        (propertyName === 'pkg_height' || propertyName === 'pkg_width')
      ) {
        this.checkPackageDimensions()
      }
      if (this.product[propertyName] === '') {
        return
      }
      const validAddress = true
      if (validAddress) {
        // if (
        //   confirm('are you sure? This will rewrite excisting product details')
        // )
        {
          this.product.prodCat_id = this.category.id
          // this.product.supplier_id = this.supplier.id
          this.$store.dispatch('product/editProduct', this.product)
          this.isEditing = !this.isEditing
          this.isActive = !this.isActive
        }
      } else {
        alert('Please enter valid address')
      }
    },
    categorySelect(option) {
      this.category = option
    },
    supplierSelect(option) {
      this.supplier = option
    },
    async saveProductVideoUrl() {
      if (this.videoUrl !== null && this.videoUrl.trim() !== '') {
        const videoData = {
          url: this.videoUrl,
          product_id: this.id
        }
        await this.$store.dispatch('product/saveProductVideoUrl', videoData)
        alert(this.$t('videoURLSuccess'))
      } else {
        this.deleteVideoUrl()
      }
    },
    async deleteVideoUrl() {
      const url = `${process.env.VUE_APP_API_URL}/product/video?product_id=${this.id}`
      try {
        await axios.delete(url)
      } catch (err) {
        // this.successMessage = err.response.data.error
      }
    },
    checkPackageDimensions() {
      this.isDimensionValid = false
      const width = this.product.pkg_width
      const height = this.product.pkg_height
      if (width && height) {
        if ((height >= 11 && width >= 15) || (width >= 11 && height >= 15)) {
          this.isDimensionValid = true
          return
        }
        if (height >= 11 && width < 15) {
          this.product.pkg_width = ''
        } else if (width >= 11 && height < 15) {
          this.product.pkg_height = ''
        } else if (width <= 11 && height <= 11) {
          this.product.pkg_width = ''
          this.product.pkg_height = ''
        }
        alert(this.$t('packageLimits'))
      } else if (width && width < 11) {
        this.product.pkg_width = ''
        alert(this.$t('packageLimits'))
      } else if (height && height < 11) {
        this.product.pkg_height = ''
        alert(this.$t('packageLimits'))
      }
    },
    contactSupplier() {
      this.$bvModal.show('product-inquiry-modal')
    },
    hideProductInquiryForm() {
      alert(this.$t('inquirySent'))
      this.$bvModal.hide('product-inquiry-modal')
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.productName {
  text-align: center;
  padding-left: 50px;
  font-size: 3em;
  width: 60%;
  // margin-bottom: 1.5rem;
}
.uploadDetails {
  font-size: 1.3em;
}
.formInput {
  text-align: left;
  margin-bottom: 5px;
}
.formYT {
  margin: 0px;
}

input::placeholder {
  padding-left: 10px !important;
}

.about-img3 {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  text-align: center;
  vertical-align: top;
}
.uploadExample {
  max-width: 200px;
  width: 100%;
}

.center {
  margin: auto;
}

.productData {
  background: var(--grey-light);
  padding: 10px;
  border-radius: 15px;
}

.field-value2 {
  display: inline;
  text-align: left;
  // width: 30%;
}

.editInstructions {
  color: var(--grey);
  font-size: 0.8em;
}

.ytIcon {
  width: 50px;
}

.titlePickUp {
  font-weight: 600;
  text-transform: uppercase;
  text-align: left;
  text-decoration: underline;
}
.limitPickUp {
  font-size: 0.8rem;
  text-align: left;
}
.errorMessage {
  margin-top: -15px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
  z-index: -1;
  text-align: left;
}
.errorMessage1 {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
  font-size: 0.68em;
  text-align: left;
}
.errorMessage2 {
  margin-top: -22px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
  z-index: -1;
  text-align: left;
}
.errorMessage3 {
  margin-top: -5px;
  margin-bottom: 0em;
  padding-top: 6px;
  color: var(--primaryDark);
  font-size: 0.6em;
  z-index: -1;
  text-align: left;
}

.optOut {
  font-weight: 600;
}
.questionMark {
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  background-color: var(--bg-light) !important;
  padding: 2px 10px !important;
  margin-left: 5px !important;
  margin-right: 3px !important;
  z-index: 1;
}

.questionMark:hover {
  background-color: var(--primaryDark) !important;
}

.questionMark1 {
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  background-color: var(--bg-light) !important;
  padding: 2px 12px !important;
  margin-left: 5px !important;
  margin-right: 3px !important;
}

.questionMark1:hover {
  background-color: var(--primaryDark) !important;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

textarea {
  padding: 10px;
  width: 100%;
  height: 180px;
}

.edit-btn {
  background: var(--bg-light);
  color: var(--bright);
  padding: 0.6em;
  margin: auto !important;
  letter-spacing: 1px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
  text-align: left;
  cursor: pointer;
}

.delete-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.6em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
}
.delete-btn:hover {
  text-decoration: none !important;
}
.delete-btn:active {
  text-decoration: none !important;
}

.delete-btn span {
  margin-left: 5px;
}

.save-btn {
  background: var(--bg-light);
  color: var(--bright);
  padding: 0.4em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  height: 38px;
  text-align: center;
  width: 120px;
}

.save-btn-box {
  margin-top: 10px;
}

.contact-btn {
  background: var(--bg-light);
  color: var(--bright);
  padding: 0.6em;
  margin: auto !important;
  letter-spacing: 1px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
  text-align: center;
  cursor: pointer;
}

.close {
  position: absolute;
  right: 35px;
  top: 25px;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.card-body {
  color: #454655;
}

.urlInput {
  width: 80%;
  height: 40px;
  border: solid 2px var(--bg-light);
  border-radius: 5px;
  margin: 20px 5px 5px 5px;
}

/** Custom CheckBox Style*/

.form-control2 {
  font-weight: bold;
  display: grid;
  grid-template-columns: 1em auto;
  text-align: left;
  gap: 0.8em;
}

.form-control2 + .form-control {
  margin-top: 1em;
}

.form-control2--disabled {
  color: var(--grey);
  cursor: not-allowed;
}

input[type='checkbox'] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--bright);
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  padding: 0px !important;
  display: grid;
  place-content: center;
}

input[type='checkbox']::before {
  content: '';
  width: 0.65em;
  height: 0.65em;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  transform: scale(0);
  transform-origin: bottom left;
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--primary);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type='checkbox']:checked::before {
  transform: scale(1);
}

input[type='checkbox']:focus {
  outline: max(2px, 0.15em) solid currentColor;
  outline-offset: max(2px, 0.15em);
}

input[type='checkbox']:disabled {
  --primary: var(--form-control-disabled);

  color: var(--form-control-disabled);
  cursor: not-allowed;
}
/** */

/*  SECTIONS  */
.section {
  clear: both;
  padding: 0px;
  margin: 0px;
}

/*  COLUMN SETUP  */
.col {
  display: block;
  float: left;
  margin: 1% 0 1% 2%;
}
.col:first-child {
  margin-left: 0;
}

/*  GROUPING  */
.group:before,
.group:after {
  content: '';
  display: table;
}
.group:after {
  clear: both;
}
.group {
  zoom: 1; /* For IE 6/7 */
}

/*  GRID OF TWO  */
.span_2_of_2 {
  width: 100%;
}
.span_1_of_2 {
  width: 49%;
}

.inactive {
  background-color: var(--primarySuperLight);
  border-radius: 3.5px;
  font-style: italic;
}
$color-1: var(--primaryDark);
$color-2: var(--bright);
$color-3: var(--bg-light);
$color-4: var(--bg-superLight);

.pricing-switcher {
  $bg-padding: 5px;
  $button-width: 110px;
  $button-height: 40px;
  $animation-time: 0.3s;
  text-align: center;
  margin-bottom: 2%;

  .fieldset {
    display: inline-block;
    position: relative;
    margin-top: 1.3em;
    padding: $bg-padding;
    border-radius: 50em;
    box-shadow: 0px 1px 5px var(--bg-superLight);
    background-color: var(--grey);
  }

  input[type='radio'] {
    position: absolute;
    opacity: 0;
  }

  label {
    position: relative;
    margin: 0;
    z-index: 1;
    display: inline-block;
    float: left;
    width: $button-width;
    height: $button-height;
    line-height: $button-height;
    cursor: pointer;
    color: $color-3;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: bold;
    transition-delay: 0.1s;
    transition: color $animation-time ease;
  }

  input[type='radio']:checked + label {
    color: $color-2;
    text-decoration: none;
  }

  .switch {
    /* floating background */
    position: absolute;
    top: $bg-padding;
    left: $bg-padding;
    height: $button-height;
    width: $button-width;
    background-color: $color-1;
    border-radius: 50em;
    transition: transform $animation-time;
  }

  input[type='radio']:checked + label + .switch,
  input[type='radio']:checked + label:nth-of-type(n) + .switch {
    /* use label:nth-of-type(n) to fix a bug on safari with multiple adjacent-sibling selectors*/
    -webkit-transform: translateX($button-width);
    -moz-transform: translateX($button-width);
    -ms-transform: translateX($button-width);
    -o-transform: translateX($button-width);
    transform: translateX($button-width);
  }
}

/*  GO FULL WIDTH AT LESS THAN 480 PIXELS */

@media only screen and (max-width: 480px) {
  .span_1_of_2 {
    width: 100%;
  }
  .span_2_of_2 {
    width: 100%;
  }
  .col {
    margin: 1% 0 1% 0%;
  }
  .input {
    width: 100%;
  }
  .formInput {
    margin: 1rem;
  }
  .productName {
    font-size: 2em;
    font-weight: 600;
    padding-left: 0;
    width: 90%;
  }
  .product-page div {
    text-align: left;
    margin-left: 20px;
  }
  .icon {
    font-size: 1.3em;
    padding: 1px;
  }
  .titlePickUp {
    text-align: center !important;
    margin-top: 50px;
  }
  .active {
    border-radius: 3.5px;
    background: none !important;
    font-weight: 800;
    // font-style: bold !important;
  }
  .active2 {
    border-radius: 3.5px;
    background: none !important;
    font-weight: 800;
    margin-left: 10px; // font-style: bold !important;
  }
  .activeSlide {
    background: none;
  }
  textarea {
    width: 100%;
    height: 150px;
  }
  .uploadDetails {
    font-size: 1.2em;
  }
  .urlInput {
    width: 80%;
  }
  .ytIcon {
    width: 30px;
  }
  .productData {
    margin-top: 30px;
  }
  .close {
    top: 5px;
  }
  .field-value2 {
    width: 20%;
  }
  .errorMessage3 {
    text-align: left;
  }
}

@media screen and (orientation: landscape) and (min-device-width: 319px) and (max-device-width: 680px) {
  .span_1_of_2 {
    width: 100% !important;
  }
}

@media screen and (min-width: 800px) {
  .productData {
    padding: 30px;
  }
}

@media screen and (min-width: 560px) {
  .mobileOnly {
    display: none;
  }
}
</style>
